import { Bundle } from '@ali/visualengine';
import React from 'react';
import Icon from './logo.tsx';
import {
  getArraySetterSnippet,
  getCnSelectSetter,
  getJSXTemplate,
  getMixedSetterSnippet,
  getObjectSetterSnippet,
} from '@/common/manager/setter-snippet';
import { getJSExpressionPrototype } from '@/common/manager/common-style';
import { getStatusDataSource } from '@/common/util/prototype-util';
import { DisplayPosition } from '@/common/manager/position/display-position';

const CnDetailInfoBundle = Bundle.createPrototype({
  title: '详情摘要（CnDetailInfo）',
  componentName: 'CnDetailInfo',
  category: '信息展示',
  icon: Icon,
  docUrl:
    'https://cone.cainiao-inc.com/market/awesome?business=internationality&id=3313',
  isContainer: true,
  canHovering: true,
  canSelecting: true,
  canDragging: true,
  enableCopy: true,
  snippets: [
    {
      screenshot:
        'https://img.alicdn.com/imgextra/i4/O1CN01SWmTZ124PT13qvuzQ_!!6000000007383-0-tps-720-236.jpg',
      label: 'CnDetailInfo',
      schema: {
        componentName: 'CnDetailInfo',
        props: {},
      },
    },
  ],
  configure: [
    {
      name: 'isCnDetailInfo',
      title: 'isCnDetailInfo',
      initialValue: true,
      display: 'none',
    },
    {
      name: '_context',
      title: '上下文',
      initialValue: {
        type: 'JSExpression',
        value: 'this',
      },
      display: 'none',
    },
    {
      name: 'title',
      title: '组件名称',
      display: 'inline',
      initialValue: 'DetailInfo1',
      setter: 'StringSetter',
    },
    {
      title: '配置详情',
      type: 'group',
      display: 'accordion',
      items: [
        {
          name: 'staticInfo',
          title: '静态数据',
          display: 'plain',
          setter: getObjectSetterSnippet({
            items: [
              {
                name: 'title',
                title: '标题',
                setter: getMixedSetterSnippet({
                  setters: [
                    {
                      componentName: 'CnI18nSetter',
                      title: '字符串',
                    },
                    {
                      componentName: 'VariableSetter',
                      title: '变量',
                    },
                  ],
                }),
              },
              {
                name: 'description',
                title: '描述',
                setter: getMixedSetterSnippet({
                  setters: [
                    {
                      componentName: 'CnI18nSetter',
                      title: '字符串',
                    },
                    {
                      componentName: 'VariableSetter',
                      title: '变量',
                    },
                    getJSXTemplate({
                      position: DisplayPosition.detailInfoDescriptionRender,
                    }),
                  ],
                }),
              },
              {
                name: 'avatar.src',
                title: '左侧头像',
                setter: getMixedSetterSnippet({
                  setters: [
                    {
                      componentName: 'StringSetter',
                      title: '字符串',
                    },
                    {
                      componentName: 'VariableSetter',
                      title: '变量',
                    },
                  ],
                }),
              },
              {
                name: 'status',
                title: '标签状态',
                setter: getMixedSetterSnippet({
                  setters: [
                    getCnSelectSetter({
                      options: getStatusDataSource(),
                    }),
                    {
                      componentName: 'VariableSetter',
                      title: '变量',
                    },
                  ],
                }),
              },
              {
                name: 'tagText',
                title: '标签',
                display:'inline',
                setter: getArraySetterSnippet({
                  configure:[
                    {
                      name:'name',
                      title:'标签名称',
                      setter:'CnI18nSetter',
                      isRequired: true,
                    }
                  ]
                }),
              },
            ],
          }),
        },
      ],
    },
    {
      title: '高级配置',
      type: 'group',
      collapsed: true,
      display: 'accordion',
      items: [
        {
          name: 'handleProps',
          title: '手动设置组件props',
          display: 'inline',
          setter: getJSExpressionPrototype({
            type: 'props',
          }),
        },
      ],
    },
  ],
});

export default CnDetailInfoBundle;
